import { createIcon } from "@chakra-ui/react";

export const PlusSolid = createIcon({
  displayName: "PlusSolid",
  viewBox: "0 0 24 24",
  d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24zm-1.125-7.875v-3h-3A1.122 1.122 0 0 1 6.75 12c0-.623.502-1.125 1.125-1.125h3v-3c0-.623.502-1.125 1.125-1.125s1.125.502 1.125 1.125v3h3c.623 0 1.125.502 1.125 1.125s-.502 1.125-1.125 1.125h-3v3c0 .623-.502 1.125-1.125 1.125a1.122 1.122 0 0 1-1.125-1.125z",
  defaultProps: {
    "aria-label": "Add symbol: A plus symbol within a circle"
  }
});

export default PlusSolid;
